import { Serializable } from '../../../core/models/serializable';

export class CustomerAddEventModel
  implements Serializable<CustomerAddEventModel>
{
  fromObject(object: any): CustomerAddEventModel {
    throw new Error('Method not implemented.');
  }
  toObject() {
    return {
      CustomerId: this.customerId,
      EventId: this.eventId,
      PackageId: this.packageId,
      Date: this.date,
    };
  }

  public customerId: number;
  public eventId: number;
  public packageId: number;
  public date: Date;
}
